export default __webpack_public_path__ + "static/media/exploring.d7ac4723.png";